import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Transfers from "../components/transfers/Transfers";
import { useUserTabEditPermissionDisabled } from "../lib/usersPermissions";

export default function TransfersPage() {
    const navigate = useNavigate()
    let transfersPermission = useUserTabEditPermissionDisabled('practice_view_transfer')

    useEffect(() => {
        if (transfersPermission != undefined && !transfersPermission) {
            return navigate("/dashboard");
        }
    }, [])

    return <Transfers />
}
